module.exports = __webpack_public_path__ + "img/logo.7329b822.svg";